module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "profit-box"
  }, [_c('div', {
    staticClass: "title-box"
  }, [_c('h3', [_vm._v(_vm._s(_vm.version.title))])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "panel",
    attrs: {
      "element-loading-spinner": "el-icon-loading"
    }
  }, [_c('profit-table', {
    attrs: {
      "thData": _vm.thData,
      "trData": _vm.trData,
      "page": _vm.page,
      "selPage": _vm.selPage,
      "curArea": _vm.curArea,
      "operate": _vm.operate,
      "multiLanguage": _vm.version
    },
    on: {
      "tableChange": _vm.requestHandle
    }
  }, [_c('div', {
    staticClass: "conditions",
    attrs: {
      "slot": "handle"
    },
    slot: "handle"
  }, [_c('div', {
    staticClass: "condition change-el-input-group-style"
  }, [_c('el-input', {
    model: {
      value: (_vm.searchVal),
      callback: function($$v) {
        _vm.searchVal = $$v
      },
      expression: "searchVal"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "105px"
    },
    attrs: {
      "slot": "prepend"
    },
    slot: "prepend",
    model: {
      value: (_vm.searchKey),
      callback: function($$v) {
        _vm.searchKey = $$v
      },
      expression: "searchKey"
    }
  }, _vm._l((_vm.version.selectArr), function(item, index) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1), _vm._v(" "), _c('el-button', {
    attrs: {
      "slot": "append"
    },
    on: {
      "click": _vm.requestHandle
    },
    slot: "append"
  }, [_vm._v(_vm._s(_vm.version.search))])], 1)], 1)])])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6a61e33a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/ProfitShareSetting/VersionReport.vue
// module id = 1124
// module chunks = 1